import script from "./SkillLanguageEditView.vue?vue&type=script&lang=ts&setup=true"
export * from "./SkillLanguageEditView.vue?vue&type=script&lang=ts&setup=true"

import "./SkillLanguageEditView.vue?vue&type=style&index=0&id=f34a3f10&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f34a3f10"]])

export default __exports__